const formatCurrency = (value?: string | number | null) => {
  if (value === null || value === undefined || value === '') {
    return '$0.00'
  }

  const number = Number(value)
  if (isNaN(number)) {
    return '$0.00'
  }

  return number.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export const formatPercent = (value?: string | number | null) => {
  if (value === null || value === undefined || value === '') {
    return '0.00%'
  }

  const number = Number(value)
  if (isNaN(number)) {
    return '0.00%'
  }

  return number.toLocaleString('en-US', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })
}

export const formatter = {
  currency: formatCurrency,
  percent: formatPercent,
}
